export default class PermissionChecker {

    constructor()
    {
        this.permissions = JSON.parse(localStorage.getItem('roles')) || [];
    }

    add(role) {
        this.permissions.push(role);
    }

    can(role) {
        if (this.inArray(role, this.permissions)) {
            return true;
        } else {
            return false;
        }
    }

    getAll() {
        return this.permissions;
    }

    inArray(needle, haystack) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(haystack[i] == needle) return true;
        }
        return false;
    }

}
